export const getThreads = () => {
  let data = require("./database.json");
  return data.threads;
};

export const getContent = (id) => {
  let data = require("./database.json");
  return data["contents"][id];
};

export const addThread = (title, text) => {
  let data = require("./database.json");
  let fs = require("fs");
  let id = data["threads"].length + 1;
  data["threads"].push({"id": id, "title": title});
  data["contents"][id] = {"text": text};
  fs.writeFile("./database.json", JSON.stringify(data, null, ' '));
}
